import { render, staticRenderFns } from "./CataloguePriceTab.vue?vue&type=template&id=0261b7c3&"
import script from "./CataloguePriceTab.ts?vue&type=script&lang=js&"
export * from "./CataloguePriceTab.ts?vue&type=script&lang=js&"
import style0 from "./CataloguePriceTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports